import * as axios from 'common/js/http'
import * as config from 'api/config'

export function getEvaluation (data, au) {
  return axios.http(config.evaluationUrl + config.resUrl.evaluation, data, au)
}

export function getEvaluationCal (data, au) {
  return axios.http(config.evaluationUrl + config.resUrl.evaluationCal, data, au)
}

export function getEvaluationSave (data, au) {
  return axios.http(config.evaluationUrl + config.resUrl.evaluationSave, data, au)
}

export function getResaultProductList (data, au) {
  return axios.http(config.productUrl + config.resUrl.productList, data, au)
}

export function getEvaluationUpdate (data, au) {
  return axios.http(config.evaluationUrl + config.resUrl.evaluationUpdate, data, au)
}

export function getEvaluationRecord (data, au) {
  return axios.http(config.evaluationUrl + config.resUrl.record, data, au)
}

export function loginGetAu (data, au) {
  return axios.http(config.investorUrl + config.resUrl.loginApp, data, au)
}

export function needSignTest (data, au) {
  return axios.http(config.investorUrl + config.resUrl.needSignTest, data, au)
}

export function quesSignSave (data, au) {
  return axios.http(config.evaluationUrl + config.resUrl.setEvaluationResultFileSign, data, au)
}

// 问卷、问题列表 http://192.168.88.120:200/index.php?s=/21&page_id=1572
export function questionNewList (data, au) {
  return axios.http(config.evaluationUrl + config.resUrl.questionNewList, data, au)
}



// WEBPACK FOOTER //
// ./src/api/evaluation.js